import type { ReactNode } from "react";
import "./HelpMessage.scss";
import IconInfoCircle from "@/shared/components/generic/icons/IconInfoCircle.tsx";

interface Properties {
  text: string;
}

export default function HelpMessage(props: Properties): ReactNode {
  return (
    <div className="help-message">
      <div className="icon">
        <IconInfoCircle />
      </div>
      <div>{props.text}</div>
    </div>
  );
}
